export default __webpack_public_path__ + "static/media/strategy2.502d0482.png";